import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './Input.module.scss'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: ReactNode
  trailingIcon?: ReactNode
  error?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { leadingIcon, trailingIcon, error, className, disabled, ...rest },
  ref,
) {
  return (
    <div className={cn(styles.wrap, error && styles.error, disabled && styles.disabled, className)}>
      {leadingIcon ? <span className={styles.adornment} aria-hidden>{leadingIcon}</span> : null}
      <input ref={ref} className={styles.input} disabled={disabled} {...rest} />
      {trailingIcon ? <span className={styles.adornment} aria-hidden>{trailingIcon}</span> : null}
    </div>
  )
})
